if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();
        if (!this.hasAttribute('available')) return;
        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) return;
        let baseUrl = this.dataset.baseUrl;
        if (!baseUrl.endsWith('/')) {
          baseUrl = baseUrl + '/';
        }
        const variantSectionUrl = `${baseUrl}variants/${variantId}/?section_id=pickup-availability`;

          fetch(variantSectionUrl)
          .then(response => response.text())
          .then(text => {
            const container = document.querySelector('[data-store-availability-container]');
            const pickupAvailabilityHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');

              container.renderPreview(pickupAvailabilityHTML);
          })
          .catch(e => {
            console.error(e);
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute('available');
          this.innerHTML = '';
        }
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(pickupAvailabilityHTML) {
        const drawer = document.querySelector('bz-pickup-drawer');
        if (drawer) drawer.remove();
        if (!pickupAvailabilityHTML.querySelector('bz-pickup-preview')) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = pickupAvailabilityHTML.querySelector('bz-pickup-preview').outerHTML;
        this.setAttribute('available', '');

        document.body.appendChild(pickupAvailabilityHTML.querySelector('bz-pickup-drawer'));
        const colorClassesToApply = this.dataset.productPageColorScheme.split(' ');
        colorClassesToApply.forEach((colorClass) => {
          document.querySelector('bz-pickup-drawer').classList.add(colorClass);
        });
        const button = this.querySelector('button');
        if (button)
          button.addEventListener('click', () => {
            document.querySelector('bz-pickup-drawer').show(button);
          });
      }
    }
  );
}

if (!customElements.get('bz-pickup-drawer')) {
  customElements.define(
    'bz-pickup-drawer',
    class bzPickupDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);
        this.querySelector('button').addEventListener('click', () => {
          this.hide();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (target != this && !target.closest('bz-pickup-drawer') && target.id != 'Bzpickupdrawer') {
          this.hide(); 
        }
      }

      hide() {
        if (!this.hasAttribute('open')) return;
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden', 'bz-pickup');
        window.BzA11y?.releaseFocus(this);
      }

      show(opener) {
        if (!this.hasAttribute('role')) this.setAttribute('role', 'dialog');
        this.setAttribute('aria-modal', 'true');
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden', 'bz-pickup');
        window.BzA11y?.trapFocus(this, { returnTo: opener || document.activeElement });
      }
    }
  );
}